/**
 * product-gallery.js — thumbnail-wissel voor de product media gallery
 * (sections/main-product.liquid, [data-gallery]).
 *
 * Klik op een thumb [data-gallery-thumb] wisselt de hoofdafbeelding
 * [data-gallery-main] en de actieve state. Delegation, dus werkt ook
 * als secties via de theme editor opnieuw gerenderd worden.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('[data-gallery]');
    var main = gallery && gallery.querySelector('[data-gallery-main]');
    if (!main) return;

    main.src = thumb.dataset.full;
    if (thumb.dataset.alt) main.alt = thumb.dataset.alt;

    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });
})();
